import { FormPayload } from '../types';
import { toSignUpAPI } from '../Api/SignUpAPI';
import { ServerError } from '../../../../Interfaces/Validation';

export interface Input {
  values: FormPayload;
  preAction: () => void;
  doAction: () => void;
  errorAction: (errors: ServerError[]) => void;
}

export const submitHandle = async ({
  values,
  preAction,
  doAction,
  errorAction,
}: Input) => {
  let res = null;
  preAction();

  try {
    res = await toSignUpAPI(values);

    doAction();
    // @ts-ignore
  } catch (e: never) {
    if (e.errors && e.errors.length !== 0) {
      errorAction(e.errors);
    }

    if (!e) return;
  } finally {
    await res;
  }
};
